import moment, { Moment } from "moment";
import { Service } from "utils/services";
import { AnimatePresence, motion } from "framer-motion";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/ui/dialog";
import { useState } from "react";
import TextInput from "components/app/function/TextInput";
import { Textarea } from "components/ui/textarea";

const HOURS = Array.from({ length: 24 }, (_, i) => `${i}:00`);
export function CalendarGrid({ days, date, setCurrentView, currentView, direction }: any) {
  const variants: any = {
    enter: (direction: "left" | "right") => ({
      x: direction === "right" ? 300 : -300,
      opacity: 0,
      position: "absolute",
    }),
    center: {
      x: 0,
      opacity: 1,
      position: "relative",
    },
    exit: (direction: "left" | "right") => ({
      x: direction === "right" ? -300 : 300,
      opacity: 0,
      position: "absolute",
    }),
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState<{ day: Moment; hour: string } | null>(null);

  return (
    <>
      <div className="relative overflow-hidden  bg-white dark:bg-[#1c212f] ">
        <AnimatePresence custom={direction} mode="wait">
          <motion.div
            key={date.format("YYYY-MM-DD") + currentView}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.3 }}
            className="w-full h-full"
          >
            <div className="w-full flex flex-col">
              {/* Header */}
              <div
                className={`grid ${
                  currentView === "day" ? "grid-cols-[90px_repeat(1,1fr)] " : currentView === "week" ? "grid-cols-[90px_repeat(7,1fr)]" : "grid-cols-7"
                } border-b text-center sticky top-0 bg-white dark:bg-[#1c212f] z-10`}
              >
                {currentView !== "month" && <div className="border-l"></div>}

                {days?.map((day: any, i: any) => {
                  console.log(days, "days");

                  const isToday = day.isSame(moment(), "dayay");
                  const isSelected = day.isSame(date, "day");
                  return (
                    <div key={i} className="py-3 flex flex-col items-center gap-1 border border-b-0 border-t-0">
                      <span className={`${isSelected ? "text-blue-600 " : isToday ? " " : "text-gray-500"} text-xs  uppercase`}>{day.format("ddd")}</span>
                      <div
                        onClick={() => {
                          setCurrentView("day");
                        }}
                        className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-semibold cursor-pointer
             ${
               isSelected
                 ? "bg-blue-600 text-white"
                 : isToday
                 ? "bg-gray-200 dark:bg-[#2c3a52] dark:text-white text-black"
                 : "text-gray-800 hover:dark:bg-[#2c3a52] dark:text-gray-300 hover:bg-gray-100"
             }`}
                      >
                        {day.date()}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Scrollable grid */}
              <div className="flex-1 overflow-y-auto">
                <div
                  className={`grid  divide-x border ${
                    currentView === "day" ? "grid-cols-[90px_repeat(1,1fr)]" : currentView === "week" ? "grid-cols-[90px_repeat(7,1fr)]" : "grid-cols-7"
                  }`}
                >
                  {/* Time column */}
                  {currentView !== "month" && (
                    <div className="flex flex-col text-xs text-gray-400 ">
                      {HOURS.map((hour, i) => (
                        <div key={i} className="min-h-[100px] px-1 flex items-center justify-center border-l-1 border-b ">
                          {Service.formatTime(hour)}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Day columns */}
                  {days?.map((day: any, i: any) => (
                    <div key={i} className="flex flex-col divide-y  ">
                      {HOURS.map((hour, h) => (
                        <div
                          onClick={() => {
                            setSelectedSlot({ day, hour });
                            setOpenModal(true);
                          }}
                          key={h}
                          className="min-h-[100px] border-l-1 cursor-pointer  "
                        ></div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
      <Dialog open={openModal} onOpenChange={setOpenModal}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Create / View Task</DialogTitle>
            <DialogDescription>{selectedSlot && `${selectedSlot.day.format("dddd, MMM D, YYYY")} at ${Service.formatTime(selectedSlot.hour)}`}</DialogDescription>
          </DialogHeader>
          {/* Your custom task form or task list goes here */}
          <div className="mt-4 space-y-2">
            <TextInput className="focus:border-none w-full rounded " placeholder="Task Title" value="" onChange={(event) => {}} />
            <Textarea placeholder="Description" value="" onChange={(e) => {}} rows={4} />
          </div>
          <DialogFooter className="mt-4">
            <button onClick={() => setOpenModal(false)} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Save
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
